var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M100,147.8l15.1-19.6H149v-62H51v62h33.8L100,147.8z M115.6,91.3h11.7V103h-11.7V91.3z M94.1,91.3h11.7V103 H94.1V91.3z M84.7,103H73V91.3h11.7V103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M161.1,175.8h-40.2v-12.4h-24c-9.8,0-17.8,8-17.8,17.8v1c0,9.8,8,17.8,17.8,17.8h24v-12.4h51.9V143h7.2 c11,0,20-9,20-20V94.4c0-11-9-20-20-20h-7.2V61.3c0-33.8-27.5-61.3-61.3-61.3h-23C54.7,0,27.2,27.5,27.2,61.3v13.2H20 c-11,0-20,9-20,20V123c0,11,9,20,20,20h18.9V61.3c0-27.3,22.2-49.5,49.5-49.5h23.1c27.3,0,49.5,22.2,49.5,49.5L161.1,175.8 L161.1,175.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTicket);
export default __webpack_public_path__ + "static/media/support-ticket.1ca058c81c9c8cee94b4baf4f7a1a457.svg";
export { ForwardRef as ReactComponent };